import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IPoster } from '../../../../../../common/common-interfaces/poster';
import { Api } from '../../services/api';
import { Globals } from '../../services/globals';

@Component({
    selector: 'image-generator',
    templateUrl: './image-generator.component.html',
    styleUrls: ['./image-generator.component.scss'],
    standalone: false
})
export class ImageGeneratorComponent {
  prompt: string = '';
  generating: boolean = false;
  upscaling: boolean = false;
  result: {
    batchId: string,
    images: {
      url: string,
      safeUrl: any,
      upscaledUrl?: string,
      upscaling?: boolean,
      createdPoster?: any,
      creatingPoster?: boolean,
      creatingShopifyProduct?: boolean,
    }[]
  } | null = null;

  viewPosterBorders: boolean = false;

  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, private sanitizer: DomSanitizer) {

  }

  async ngOnInit() {

  }

  async generate() {
    this.generating = true;
    let result = await this.api.store().post<any>(`/third-party/openai/dalle/generate-image`, { prompt: this.prompt });

    this.result = {
      batchId: result.batchId,
      images: result.result.data.map((d: any) => {
        return {
          url: d.url,
          safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(d.url)
        }
      })
    };

    this.generating = false;
  }

  async upscale(index: number) {
    if (this.result) {
      this.upscaling = true;
      this.result.images[index].upscaling = true;
      let result = await this.api.store().post<any>(`/third-party/bigjpg/upscale-image-generation-batch/${this.result?.batchId}/${index}`, {});


      let i = setInterval(async () => {
        let result = await this.api.store().get<any>(`/third-party/bigjpg/get-status/${this.result?.batchId}/${index}`);

        if (this.result && result.result.status == 'success') {
          this.result.images[index].upscaledUrl = result.upscaledUrl;
          this.result.images[index].upscaling = false;
          this.upscaling = false;
        }

        if (result.result.status == 'error' || result.status == 'success') {
          this.upscaling = false;
          clearInterval(i);
        }

      }, 1000);

    }
  }

  async createPoster(index: number) {
    if (this.result) {
      this.result.images[index].creatingPoster = true;
      let result = await this.api.store().post<any>(`/posters/create-from-image-generation/${this.result?.batchId}/${index}`, {});

      if (this.result && result.succeeded) {
        this.result.images[index].createdPoster = result.poster;

        let descriptionResult = await this.api.store().post<any>(`/posters/${result.poster._id}/auto-generate-description`, {});

      }
      this.result.images[index].creatingPoster = false;
    }
  }

  async createShopifyProduct(image: any) {
    if (this.result) {
      let poster = image.createdPoster;
      image.creatingShopifyProduct = true;
      let result = await this.api.store().post<any>(`/posters/${poster._id}/create-shopify-product`, {});
      if (result)
        poster.thirdParty = result.thirdParty;
      image.creatingShopifyProduct = false;
    }
  }

  startOver() {
    this.result = null;
  }

}
